module.exports = __webpack_public_path__ + "img/tax-vat.21c19415.svg";